import React from 'react';
import '@ant-design/compatible/assets/index.css';
import { Layout } from 'antd';
import 'antd/dist/antd.css';
// import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
// import { ActionCreators } from '../redux/actions';
// import * as Service from '../core/Service';
// import Sidebar from '../components/Sidebar';
// import Navbar from '../components/Navbar';
import AppLayout from '../components/AppLayout';
// import _ from 'lodash';
// import moment from 'moment';
import { useTranslation } from 'react-i18next';

const { Content } = Layout;

// const styles = {
//   chartCol: {
//     height: "400px",
//     textAlign: "center",
//     // border: 'solid 1px #ccc',
//     padding: '30px 10px 60px',
//     borderRadius: '5px',
//     boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.15)'
//   },
// }

const Home = () => {
  const { t } = useTranslation();

  return (
    <AppLayout title='主頁'>
      <Content
      style={{
        height:'100%',
      }}
      >
      </Content>
    </AppLayout>
  )
}


export default Home;